export default __webpack_public_path__ + "static/media/somaa - SOMYA ARORA.1e2f7905.jpg";